"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.default = {
    root: {
        display: 'block',
        width: 28,
        height: 'auto',
        fill: globalStyle_1.default.indigo1
    },
    bands: {
        '& > circle:nth-child(1)': {
            fill: globalStyle_1.default.teal2
        },
        '& > circle:nth-child(2)': {
            fill: globalStyle_1.default.teal1
        },
        '& > circle:nth-child(3)': {
            fill: globalStyle_1.default.indigo4
        },
        '& > circle:nth-child(4)': {
            fill: globalStyle_1.default.indigo3
        },
        '& > circle:nth-child(5)': {
            fill: globalStyle_1.default.indigo2
        },
        '& > circle:nth-child(6)': {
            fill: globalStyle_1.default.indigo1
        }
    }
};
//# sourceMappingURL=traceLogomark.styles.js.map